import { styled } from '@mui/material';

import { useMemo } from 'react';

import { useI18n } from '@app-velocity/i18n';

import { ClearIcon, EyeIcon } from '@app-velocity/icons';
import { ButtonsContainer } from '@app-velocity/ui';

import { useScenarioDetailsContext, useScenarioHeatmapContext } from '@app-velocity/modules/scenarios';

const StyledButton = styled('button')({
  background: 'transparent',
  border: 'none',
  color: 'var(--color-blue-500)',
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  cursor: 'pointer',
  padding: 0,
  fontSize: 12,
});

const StyledClearButton = styled('button')({
  background: 'transparent',
  border: 'none',
  color: 'var(--color-neutral-900)',
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  cursor: 'pointer',
  padding: 0,
  fontSize: 12,
});

export type ClickMapActionsProps = {
  generate: () => void;
  clear: () => void;
};

export const ClickMapActions = ({ generate, clear }: ClickMapActionsProps) => {
  const { t } = useI18n();

  const { scenario } = useScenarioDetailsContext();
  const { heatMapLayers } = useScenarioHeatmapContext();

  const possibleToClear = useMemo(() => {
    return scenario.prototypePages!.some((page) => {
      return heatMapLayers.some((layer) => layer.includes(page.fileName!));
    });
  }, [heatMapLayers, scenario]);

  return (
    <ButtonsContainer align="start">
      <StyledButton onClick={generate}>
        {t('prototypes:render_clickmap')}
        <EyeIcon />
      </StyledButton>
      {possibleToClear ? (
        <StyledClearButton onClick={clear}>
          {t('prototypes:clear_clickmap')}
          <ClearIcon />
        </StyledClearButton>
      ) : null}
    </ButtonsContainer>
  );
};
